module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAAY1BMVEUAAAA1QEBVVVUzNjszNzszNzozNjwzNzoyOT1JSUkzNzsyNjszNzszNzoyNzs3Nz0zOT4zNzsyNjr///+anJ7LzM1laGvh4uJaXWD29vZNUVR2eXvg4eHS09Tw8fH7/Pz19fWwR3cnAAAAEnRSTlMAGAbZv5WW8UcHgvTH4/MuLfISO1TyAAAAzUlEQVQ4y4WTVxLCMAwFTXoH1nF64f6npE4GSDTaXz8VS3rGbHhJGPhV5Qdh4pk9pyhmI45Of89plkNXu7bvW1d3kGfpT3gB42Q3phGKryTnkmG2P8wD5WWLL2kW+8fSUH5ypAXNanesDcW7j4xhsQcsA9mrQM5sD5nJn0UiRiswEj3mFzNJgonYMwmdFelITEgtC2pCE+BkgSMwPq0saPFNRS8LeqqH4CYLblz1EmqT6jfVQamjVpelr1s9GP3k1KPVz143jm493byy/e+F5zvgWOm00wAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/components/questions/choose_one/assets/radio.png
// module id = 531
// module chunks = 0